import React from "react";

const QuizResult = ({ answers, onRestart }) => {
  const correct = answers.filter(Boolean).length;
  const total = answers.length;
  const pct = Math.round((correct / total) * 100);

  const circumference = 2 * Math.PI * 54;
  const offset = circumference - (pct / 100) * circumference;

  let msg = "Daha cok calis!";
  let color = "#ef4444";
  if (pct === 100) { msg = "Mukemmel!"; color = "#22c55e"; }
  else if (pct >= 70) { msg = "Harika!"; color = "#22c55e"; }
  else if (pct >= 50) { msg = "Fena degil!"; color = "#f59e0b"; }

  return (
    <div className="panel result-panel">
      <div className="ring-wrap">
        <svg className="ring-svg" viewBox="0 0 120 120">
          <circle cx="60" cy="60" r="54" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="8" />
          <circle
            cx="60" cy="60" r="54" fill="none"
            stroke={color} strokeWidth="8" strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            className="ring-progress"
          />
        </svg>
        <div className="ring-label">
          <span className="ring-pct">{pct}%</span>
        </div>
      </div>

      <p className="r-msg" style={{ color }}>{msg}</p>
      <p className="r-sub">{total} sorudan {correct} dogru cevap</p>

      <div className="r-boxes">
        <div className="r-box r-box-ok">
          <span className="r-box-num">{correct}</span>
          <span className="r-box-label">Dogru</span>
        </div>
        <div className="r-box r-box-no">
          <span className="r-box-num">{total - correct}</span>
          <span className="r-box-label">Yanlis</span>
        </div>
      </div>

      <button className="btn" onClick={onRestart}>Tekrar Oyna</button>
    </div>
  );
};

export default QuizResult;
